import axios from 'axios'
import { rejectError } from '../helper'

const transformRequest = (jsonData = {}) => Object.entries(jsonData)
  .map((x) => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
  .join('&')

export default {
  state: {
    token: null,
    username: null,
    user: null,
  },
  mutations: {
    setToken (state, token) {
      state.token = token
    },
    setUsername (state, username) {
      state.username = username
    },
    storeUser (state, user) {
      state.user = user
    },
    clearAuthData (state) {
      state.token = null
      state.username = null
      state.user = null
    },
  },
  getters: {
    user (state) {
      return state.user
    },
    isAuthenticated (state) {
      return state.token !== null
    },
    getUsername (state) {
      return state.username
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    login ({ commit, dispatch }, data) {
      const args = {
        grant_type: 'password',
        client_id: 'cuebroadcast@master',
        username: data.username,
        password: data.password,
      }
      return axios.post('https://cue-mha001.epicvideo.tech/sdp/v2/authorize', transformRequest(args), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      })
        .then((res) => {
          localStorage.setItem('token', res.data.data)
          commit('setUsername', data.username)
          localStorage.setItem('username', data.username)
          return commit('setToken', res.data.data)
        })
        .catch((error) => rejectError(error))
    },
    checkToken ({ commit, dispatch }, token) {
      const params = {}
      const headers = {
        'X-Auth-Token': token,
      }
      return axios.get('https://cue-mha001.epicvideo.tech/sdp/v2/managers/me', {
        params,
        headers,
      })
        .then(() => {
          localStorage.setItem('token', token)
          commit('setToken', token)
          return dispatch('fetchUser')
        })
        .catch((error) => {
          commit('clearAuthData')
          return rejectError(error)
        })
    },
    fetchUser ({ commit, state }) {
      if (!state.token) {
        return
      }
      const headers = {
        'X-Auth-Token': state.token,
      }
      axios.get('https://cue-mha001.epicvideo.tech/sdp/v2/operators/me', { headers })
        .then(() => {
        })
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    logout ({ commit }) {
      commit('clearAuthData')
      localStorage.removeItem('token')
      localStorage.removeItem('calendarInterval')
    },
    // eslint-disable-next-line no-unused-vars
    tryAutoLogin ({ commit, state, dispatch }) {
      const token = localStorage.getItem('token')
      if (!token) {
        commit('clearAuthData')
        return
      }
      commit('setToken', token)

      dispatch('fetchUser')

      const username = localStorage.getItem('username')
     // if (!username) {
       // dispatch('fetchUser')
      // }
      commit('setUsername', username)
    },
  },
}
